<ng-container *ngIf="viewModel$ | async as vm">
  <ion-card
    class="usf-order-card-info"
    [class.usf-border-bottom]="!lastItem"
    [class.hide-subbed-item]="shouldHideSubbedItem"
    [ngClass]="processed ? 'processed-card-border' : ''"
    (click)="!processed && selectProduct()"
  >
    <div class="original-block" *ngIf="!processed">
      <div *ngIf="!isInStock" class="top-drawer autosub-top-drawer">
        <ion-icon
          data-cy="product-card-top-drawer-icon"
          name="close-circle-outline"
        ></ion-icon>
        <p class="atp" data-cy="product-card-top-drawer-text">
          <span data-cy="product-card-top-drawer-subtext-1 atp">
            <span class="autosub-bold"
              >{{ 'i18n.productDetail.outOfStock' | translate }}.</span
            >
            {{ vm.expectedInStock }}
          </span>
        </p>
      </div>
      <div
        class="usf-order-card-info-inner"
        *ngIf="
          platformService.platformType !== platformService.platformEnum?.mobile
        "
      >
        <div class="usf-order-card-img">
          <img
            *ngIf="!!vm.thumbnailImageURL"
            [src]="vm.thumbnailImageURL"
            (error)="
              vm.thumbnailImageURL = getAternativeThumbnail(
                vm.thumbnailImageURL
              )
            "
            [attr.data-cy]="
              'submitted-product-' + productSummary?.productNumber + '-image'
            "
            (click)="productClickHandler()"
          />
          <ion-icon
            name="restaurant"
            *ngIf="!vm.thumbnailImageURL"
            data-cy="submitted-no-product-image"
            class="no-image"
            (click)="productClickHandler()"
          ></ion-icon>
        </div>
        <div class="usf-order-card-desc">
          <div
            class="usf-order-card-desc-body-txt"
            (click)="productClickHandler()"
          >
            {{ productSummary?.brand | titlecase }}
          </div>
          <div class="usf-order-card-desc-heading-txt">
            <a (click)="productClickHandler()">
              {{ productSummary?.productDescTxtl | titlecase }}
            </a>
          </div>
          <div class="usf-order-card-desc-body-txt">
            <div>#{{ productSummary?.productNumber }}</div>
            <span *ngIf="productSummary?.salesPackSize"
              >| {{ productSummary?.salesPackSize }}</span
            >
            <span>|</span>
            <span class="bold" class="hide-product-number-mobile bold">
              {{ 'i18n.orderExceptionsPage.originalPrice' | translate }}
            </span>
            <span *ngIf="item?.unitsReserved > 0">
              {{ item?.unitPrice | currency }}
              {{ item?.priceUOM ? item?.priceUOM : 'CS' }}
            </span>
            <span *ngIf="item?.unitsReserved > 0 && item?.eachesReserved > 0"
              >/</span
            >
            <span *ngIf="item?.eachesReserved > 0">
              {{ item?.eachPrice | currency }}
              {{ item?.priceUOM ? item?.priceUOM : 'EA' }}
            </span>
          </div>
          <div class="usf-order-card-totals-inner">
            <p>
              <span>{{ 'i18n.orderPage.reserved' | translate }}</span>
              {{ item?.unitsReserved || 0 }} CS /
              {{ item?.eachesReserved || 0 }} EA
            </p>
            <p>
              <span>{{ 'i18n.orderPage.shipped' | translate }}: </span>
              {{ item?.unitsOrdered?.currentValue || 0 }} CS /
              {{ item?.eachesOrdered?.currentValue || 0 }} EA
            </p>
            <p *ngIf="item?.totalDollars || item?.totalDollars === 0">
              <span>{{ 'i18n.orderPage.lineTotal' | translate }}</span>
              {{ item?.totalDollars | currency }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="usf-order-card-info-inner-mobile"
        *ngIf="
          platformService.platformType === platformService.platformEnum?.mobile
        "
      >
        <div class="usf-order-card-mobile">
          <div class="usf-order-card-img">
            <img
              *ngIf="!!vm.thumbnailImageURL"
              [src]="vm.thumbnailImageURL"
              (error)="
                vm.thumbnailImageURL = getAternativeThumbnail(
                  vm.thumbnailImageURL
                )
              "
              [attr.data-cy]="
                'submitted-product-' + productSummary?.productNumber + '-image'
              "
              (click)="productClickHandler()"
            />
            <ion-icon
              name="restaurant"
              *ngIf="!vm.thumbnailImageURL"
              data-cy="submitted-no-product-image"
              class="no-image"
              (click)="productClickHandler()"
            ></ion-icon>
          </div>
          <div class="usf-order-card-desc">
            <div
              class="usf-order-card-desc-body-txt"
              (click)="productClickHandler()"
            >
              {{ productSummary?.brand | titlecase }}
            </div>
            <div class="usf-order-card-desc-heading-txt">
              <a (click)="productClickHandler()">
                {{ productSummary?.productDescTxtl | titlecase }}
              </a>
            </div>
          </div>
        </div>
        <div class="usf-order-card-desc-body-mobile">
          <div class="usf-order-card-desc-body-txt">
            <div>#{{ productSummary?.productNumber }}</div>
            <span *ngIf="productSummary?.salesPackSize"
              >| {{ productSummary?.salesPackSize }}</span
            >
            <span>|</span>
            <span class="bold" class="hide-product-number-mobile bold">
              {{ 'i18n.orderExceptionsPage.originalPrice' | translate }}
            </span>
            <span *ngIf="item?.unitsReserved > 0">
              {{ item?.unitPrice | currency }}
              {{ item?.priceUOM ? item?.priceUOM : 'CS' }}
            </span>
            <span *ngIf="item?.unitsReserved > 0 && item?.eachesReserved > 0"
              >/</span
            >
            <span *ngIf="item?.eachesReserved > 0">
              {{ item?.eachPrice | currency }}
              {{ item?.priceUOM ? item?.priceUOM : 'EA' }}
            </span>
          </div>
          <div class="usf-order-card-totals-inner-mobile">
            <div>
              <div class="usf-order-card-totals-inner-mobile-values">
                <span class="bold">{{
                  'i18n.orderPage.reserved' | translate
                }}</span>
                {{ item?.unitsReserved || 0 }} CS /
                {{ item?.eachesReserved || 0 }} EA
              </div>
              <div class="usf-order-card-totals-inner-mobile-values">
                <span class="bold"
                  >{{ 'i18n.orderPage.shipped' | translate }}:
                </span>
                {{ item?.unitsOrdered?.currentValue || 0 }} CS /
                {{ item?.eachesOrdered?.currentValue || 0 }} EA
              </div>
            </div>
            <div>
              <div
                *ngIf="item?.totalDollars || item?.totalDollars === 0"
                class="usf-order-card-totals-inner-mobile-values"
              >
                <span class="bold">{{
                  'i18n.orderPage.lineTotal' | translate
                }}</span>
              </div>
              <div class="usf-order-card-totals-inner-mobile-values">
                {{ item?.totalDollars | currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="processed-block" *ngIf="processed">
      <div
        class="usf-order-card-info-inner-processed"
        *ngIf="
          platformService.platformType !== platformService.platformEnum?.mobile
        "
      >
        <div class="processed-block-details-container">
          <div class="added-to-order-container">
            <span class="added-to-order-title">
              {{ 'i18n.notifications.warehouseCuts.addedToOrder' | translate }}
            </span>
            <span class="added-to-order-text">
              {{ 'i18n.notifications.warehouseCuts.lastUpdatedBy' | translate }}
            </span>
            <span class="added-to-order-text">
              {{ lastUpdatedBy }}
            </span>
          </div>

          <div class="usf-order-card-img">
            <img
              *ngIf="!!vm.thumbnailImageURL"
              [src]="vm.thumbnailImageURL"
              (error)="
                vm.thumbnailImageURL = getAternativeThumbnail(
                  vm.thumbnailImageURL
                )
              "
              [attr.data-cy]="
                'submitted-product-' + productSummary?.productNumber + '-image'
              "
              (click)="productClickHandler()"
            />
            <ion-icon
              name="restaurant"
              *ngIf="!vm.thumbnailImageURL"
              data-cy="submitted-no-product-image"
              class="no-image"
              (click)="productClickHandler()"
            ></ion-icon>
          </div>
          <div>
            <div
              class="usf-order-card-desc-body-txt"
              (click)="productClickHandler()"
            >
              {{ productSummary?.brand | titlecase }} | #{{
                productSummary?.productNumber
              }}
            </div>
            <div class="usf-order-card-desc-heading-txt">
              <a (click)="productClickHandler()">
                {{ productSummary?.productDescTxtl | titlecase }}
              </a>
            </div>
          </div>
        </div>
        <div>
          <a (click)="orderClickHandler()" class="added-to-order-link">
            {{ 'i18n.notifications.warehouseCuts.view' | translate }}
          </a>
        </div>
      </div>
      <div
        class="usf-order-card-info-inner-processed"
        *ngIf="
          platformService.platformType === platformService.platformEnum?.mobile
        "
      >
        <div>
          <div
            class="usf-order-card-desc-body-txt"
            (click)="productClickHandler()"
          >
            {{ productSummary?.brand | titlecase }}
          </div>
          <div class="usf-order-card-desc-heading-txt">
            <a (click)="productClickHandler()">
              {{ productSummary?.productDescTxtl | titlecase }}
            </a>
          </div>
          <div class="added-to-order-container">
            <span class="added-to-order-title">
              {{ 'i18n.notifications.warehouseCuts.addedToOrder' | translate }}
            </span>
            <span class="added-to-order-text">
              {{ 'i18n.notifications.warehouseCuts.lastUpdatedBy' | translate }}
            </span>
            <span class="added-to-order-text">
              {{ lastUpdatedBy }}
            </span>
          </div>
        </div>
        <div>
          <a (click)="orderClickHandler()" class="added-to-order-link">
            {{ 'i18n.notifications.warehouseCuts.view' | translate }}
          </a>
        </div>
      </div>
    </div>
  </ion-card>
</ng-container>
